import { permutiveSphl } from "@app/providers/scripts/permutive";
import { PERMUTIVE_SCRIPT } from "@config/AdsConstants";
import { SCRIPT_DELAY_MS } from "@config/Constants";
import useLink from "@hooks/useLink";
import useScript from "@hooks/useScript/useScript";
import useScriptFunction from "@hooks/useScriptFunction/useScriptFunction";

import domains from "./scripts/domains";
import { taboolaScript } from "./scripts/taboola";

export default function HeadScriptProvider(): null {
  // Preconnect Scripts most frequently used
  useLink({
    id: "preconnect-googletagmanager",
    rel: "preconnect",
    href: domains.googletagmanager,
  });
  useLink({
    id: "preconnect-mysph",
    rel: "preconnect",
    href: domains.mysph,
  });
  useLink({
    id: "preconnect-doubleclick",
    rel: "preconnect",
    href: domains.doubleclick,
  });
  useLink({
    id: "preconnect-permutive",
    rel: "preconnect",
    href: domains.permutive,
  });
  useLink({
    id: "preconnect-adtag",
    rel: "preconnect",
    href: domains.adtag,
  });
  useLink({
    id: "preconnect-taboola",
    rel: "preconnect",
    href: domains.taboola,
  });

  // Taboola Script — deferred until browser is idle to avoid blocking TTI
  useScriptFunction({
    id: "taboola-script",
    value: taboolaScript,
    delayMs: SCRIPT_DELAY_MS,
  });

  // Edge Permutive App — deferred until browser is idle
  useScript({
    id: "edge-permutive-app",
    src: PERMUTIVE_SCRIPT,
    type: "text/javascript",
    delayMs: SCRIPT_DELAY_MS,
  });

  // Permutive SPHL — deferred until browser is idle
  useScriptFunction({
    id: "permutive-sphl",
    value: permutiveSphl,
    delayMs: SCRIPT_DELAY_MS,
  });

  return null;
}
